import React from 'react';
import { CompleteButton } from './SharedStyles';

const COMPLETION_CONTENT = {
  title: 'Thanks for your review!',
  description1: 'Your thoughts will help others find the perfect product.',
  description2: 'We truly appreciate you taking the time!',
  buttonText: 'Done',
} as const;

interface CompleteViewProps {
  onContinue: () => void;
}

/**
 * The button only closes. It used to navigate to /shop/, which threw away the product page the
 * reviewer had just been reading — they came to say something about that product, not to be sent
 * somewhere else once they had.
 *
 * Laid out in normal flow rather than pinned: the sheet that hosts this already scrolls its content
 * and carries its own bottom padding, and a `position: fixed` footer inside it was measured against
 * the animating sheet rather than the viewport, so the button landed under the sheet's own padding
 * and was clipped by its `overflow-hidden`.
 */
export const CompleteView = ({ onContinue }: CompleteViewProps) => (
  <div className="flex flex-col gap-12 w-full">
    <div className="flex flex-col gap-4 items-start w-full">
      <p className="text-paragraph-large font-semibold text-neutral-800">{COMPLETION_CONTENT.title}</p>
      <p className="text-label-medium text-neutral-600">{COMPLETION_CONTENT.description1}</p>
      <p className="text-label-medium text-neutral-600">{COMPLETION_CONTENT.description2}</p>
    </div>
    <CompleteButton onClick={onContinue}>
      <span className="text-paragraph-small font-medium text-generic-0">{COMPLETION_CONTENT.buttonText}</span>
    </CompleteButton>
  </div>
);
